
/*** Base Components ***/
import './vendor/jquery-3.3.1/main.js';
import './vendor/bootstrap-4.2.1/main.js';
import './vendor/noty-3.2/noty.js';
import './vendor/sticky-sidebar-3.2/main.js';
import './vendor/swiper-4.5.0/js/swiper.js';
import './vendor/vegas-bg-slider/main.js';

/*** Shared Components ***/
import './components/jquery-swipe/main.js';
import './components/scroll-top/main.js';
import './components/current-url/main.js';
import './components/animate/main.js';
import './components/ajax-modal/main.js';
import './components/window-popup/main.js';
import './components/confirm-action/main.js';

/*** Web Module ***/
import './module/main.js';